import { t } from 'i18next';

import { ErrorResponseErrorItemCodeExternalSource } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeExternalSource, string> => ({
  'external_source:invalid_s3_base_url': t('externalSource.invalidS3BaseUrl', {
    ns: 'apiErrorCodes',
    defaultValue:
      'Den angivna externa källan är ogiltig. S3-root-URL:en är inte korrekt definierad. \nKontrollera att URL:en följer rätt format.',
  }),
  'external_source:invalid_source_properties': t('externalSource.invalidSourceProperties', {
    ns: 'apiErrorCodes',
    defaultValue:
      'Det går inte att nå den angivna S3-platsen med den angivna bas-URL:en, regionen eller autentiseringsuppgifterna.',
  }),
});
